import { createAction, createAsyncThunk } from '@reduxjs/toolkit'
import { dataIdo, dataUser, stageListItems } from "./types"

export const fetchDataIdo = createAction<dataIdo>('privatesale/fetchDataIdo')
export const fetchDataUser = createAction<dataUser>('privatesale/fetchDataUser')
export const fetchStatus = createAction<{status:boolean}>('privatesale/fetchStatus')
export const fetchStageList = createAction<stageListItems>('privatesale/fetchStageList')